import { render, staticRenderFns } from "./templatekorporasi.vue?vue&type=template&id=082355c9&scoped=true&"
import script from "./templatekorporasi.vue?vue&type=script&lang=js&"
export * from "./templatekorporasi.vue?vue&type=script&lang=js&"
import style0 from "./templatekorporasi.vue?vue&type=style&index=0&id=082355c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082355c9",
  null
  
)

export default component.exports